module.exports = __webpack_public_path__ + "img/logo.4890f07b.png";